import { Link } from "react-router-dom";

const QuickPayments = () => {
    return (
        <div>
            <div className="flex flex-col justify-center items-center">
            <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
            <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
                
                <div className="flex flex-col justify-center">
                    <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                        Fulfilment Services
                    </h1>
                    <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                        TCS offers a one-stop solution to fulfil all e-com needs and empowers online businesses without 
                        the need to invest in their own fulfilment facilities with tools required to meet the challenges 
                        of an eternally competitive online market.
                    </p>
                    <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                        Our top of the line tool Envio, offers a one-window solution for all online business needs, ranging 
                        from booking and tracking multiple shipments at once, creating location-wise cost centres, multiple 
                        pickup/delivery options, to logging complaints and facilitating return logistics—all within the 
                        reach of a few clicks and without the hassle of having to manage the exhaustive paperwork.
                    </p>
                    {/* <div className=" mt-[1rem] w-[100%]">
                        
                        <div className="flex justify-left ">
                            <Link to="/open-account" className="flex justify-center text-center items-center h-9 mt-[2px] rounded-sm text-white bg-[#D40511] border border-[#F21E26] w-[10rem] rounded-md mt-[1rem] p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500">
                                Open an Account
                            </Link>
                            
                        </div>
                      </div> */}
                </div>
                <div className="flex-1 flex flex-col justify-center lg:mt-[0rem] mt-[1rem]">
                    <img src="/ecom-solution/fulfilment-center.jpg" alt="" className="max-w-[100%] rounded-md"/>
                </div>
                </div>
               
            </div>
            
        </div>
    )
}
export default QuickPayments;